import { HttpMethod } from '@ori/checkout-utils';
import { ContentType, HttpHeader } from '../types';
export const getHttpRequestSettings = (data, method = HttpMethod.Get) => {
  const headers = {
    [HttpHeader.ContentType]: ContentType.Json
  };
  let body;
  if (data) {
    const {
      placement,
      ...finalData
    } = data;
    if (placement !== undefined) {
      headers[HttpHeader.Placement] = placement;
    }
    const bodyValue = JSON.stringify(finalData);
    body = bodyValue === '{}' ? undefined : bodyValue;
  }
  return {
    credentials: 'same-origin',
    headers,
    method,
    ...(method === HttpMethod.Post && Boolean(body) && {
      body
    })
  };
};
//# sourceMappingURL=getHttpRequestSettings.js.map